import { render } from "./DataLogging.vue?vue&type=template&id=54acc4f7&scoped=true"
import script from "./DataLogging.vue?vue&type=script&lang=js"
export * from "./DataLogging.vue?vue&type=script&lang=js"

import "./DataLogging.vue?vue&type=style&index=0&id=54acc4f7&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54acc4f7"]])

export default __exports__